/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_StepInputs */

const en_ui_more_stats_step = /** @type {(inputs: Ui_More_Stats_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step length`)
};

const de_ui_more_stats_step = /** @type {(inputs: Ui_More_Stats_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt`)
};

/**
* | output |
* | --- |
* | "Step length" |
*
* @param {Ui_More_Stats_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_step = /** @type {((inputs?: Ui_More_Stats_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_step(inputs)
	return de_ui_more_stats_step(inputs)
});